import React, { useState } from 'react';
import { Card, NavItem, TabContent, TabPane, NavLink, Container, Nav, CardHeader, Row, Col } from "reactstrap";
import '../global/GlobalCSS.css';
import Layout from '../HorizontalMenu/Menu';
import Navbar from '../HorizontalMenu/Navbar';
import { useDispatch, useSelector } from 'react-redux';
import { VesselState, setVesselState } from "../Store/Generic/ReportingSlice";
import VesselDetailsHeader from '../Components/VesselDetailsHeader';
import classnames from "classnames";
import OngoingReports from './OngoingReports';
import CompletedReports from './CompletedReports';
import { useDocumentTitle } from 'Components/useDocument.hooks';
import { Get } from 'VesselMaster/vesselMaster.hooks';
import { useQuery } from 'react-query';
import { queryKeyes } from 'shared/queryKeys';
import { RootState } from 'index';

const VesselReportingInfo = ({
    tabId
}: any) => {
    const { VoyageID, VesselID } = useSelector((state: RootState) => state.Reporting);
    const [activeSettingsTab, setActiveSettingsTab] = useState(tabId);
    const dispatch = useDispatch();
    useDocumentTitle((activeSettingsTab === '1' ? "Ongoing Reports - ecoSAIL" : "Completed Reports - ecoSAIL"));

    const { data: reports, isLoading: reportsLoading, isError: reportsError } = useQuery(
        [queryKeyes.vessel.vesselVoyageReporting.key, VesselID, VoyageID],
        async () => { return await Get(queryKeyes.vessel.vesselVoyageReporting.url(VesselID, VoyageID), VesselID, VoyageID); },
        { staleTime: Infinity }
    )
    const toggle = (tab: any) => {
        if (activeSettingsTab !== tab) {
            setActiveSettingsTab(tab);
        }
    }

    const handleVesselState = (record: VesselState) => {
        dispatch(setVesselState(record))
    }
    return (
        <React.Fragment>
            <Layout>
                <Navbar />
            </Layout>
            <div className="page-content">
                <Container fluid>
                    <Card>
                        <CardHeader className='pb-0'>
                            <Row>
                                <Col sm={2}>
                                    <button color='primary' className='btn btn-primary mb-3' onClick={() => { handleVesselState('VOYAGE_REPORTING') }}><i className="bx bx-chevron-left me-1" />Back</button>
                                </Col>
                                <Col sm={10}>
                                    <VesselDetailsHeader />
                                </Col>
                            </Row>
                            <Nav tabs className='border-0'>
                                <NavItem>
                                    <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({
                                            active: activeSettingsTab === "1",
                                        })}
                                        onClick={() => {
                                            toggle("1");
                                        }}
                                    >
                                        Ongoing Reports
                                    </NavLink>
                                </NavItem>
                                <NavItem>
                                    <NavLink
                                        style={{ cursor: "pointer" }}
                                        className={classnames({
                                            active: activeSettingsTab === "2",
                                        })}
                                        onClick={() => {
                                            toggle("2");
                                        }}
                                    >
                                        Completed Reports
                                    </NavLink>
                                </NavItem>
                            </Nav>
                        </CardHeader>
                        <TabContent activeTab={activeSettingsTab} className="text-muted">
                            <TabPane tabId="1" className='margin-16'>
                                <OngoingReports
                                    reports={reports}
                                    reportsError={reportsError}
                                    reportsLoading={reportsLoading}
                                />
                            </TabPane>
                            <TabPane tabId="2" className='margin-16'>
                                <CompletedReports />
                            </TabPane>
                        </TabContent>
                    </Card>
                </Container>
            </div>
        </React.Fragment>
    )
}
export default VesselReportingInfo;